import { useForm, FormProvider } from 'react-hook-form';
import React, { useEffect, useRef } from 'react';
import {
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Button,
} from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InputFiles from 'components/Commun/Form/InputFiles';
import { postAPI, getAPI } from 'store/apiReducer';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
    API_GET_DECLARATIONS_ARMES,
    API_GET_MES_DEMARCHES_EN_COURS,
    API_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
    CONTEXT_GET_DECLARATIONS_ARMES,
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_MES_DEMARCHES_EN_COURS,
} from '../../../../../constants/apiUrls.constants';
import {
    tailleFichiers,
    mimeTypesAccepted,
    formatFichiers,
} from '../completerDemandePiecesJointes/ModaleModifierPiecesJointes.constants';

const ModaleCertificatMedicalDeclaration = ({
    fermerModale,
    postApi,
    getApi,
    isLoading,
    uuidDeclaration,
    data,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
    });

    const { handleSubmit, formState, register, getValues } = hookForm;

    useEffect(() => {
        if (data) {
            getApi(usagerClientReducer, API_GET_DECLARATIONS_ARMES, CONTEXT_GET_DECLARATIONS_ARMES);
            getApi(
                usagerClientReducer,
                API_GET_NOMBRE_NOTIFICATIONS,
                CONTEXT_GET_NOMBRE_NOTIFICATIONS,
            );
            fermerModale();
        }
    }, [data]);

    const onSubmit = async (formData) => {
        const dataDeclaration = {
            uuidDeclaration,
            certificatMedical: [await formData.certificatMedical[0].getFileToSend()],
        };
        postApi(
            usagerClientReducer,
            API_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
            dataDeclaration,
            CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
        );
        getApi(usagerClientReducer, API_GET_MES_DEMARCHES_EN_COURS, CONTEXT_MES_DEMARCHES_EN_COURS);
    };

    const disableBoutonValider = () => {
        if (!getValues('certificatMedical')) {
            return true;
        }
        return formState.errors.certificatMedical != null && getValues('certificatMedical') != null;
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalV2
                        id="ajouterCertificatMedical"
                        idModalTitle="ajouterCertificatMedical-title"
                        size="lg"
                        onClose={fermerModale}
                        ref={dialog}
                    >
                        <ModalV2Content>
                            <ModalV2Title id="ajouterCertificatMedical-title">
                                Ajouter mon certificat médical
                            </ModalV2Title>

                            <p>
                                Lors de l&apos;instruction de votre déclaration de détention, il a
                                été remonté à notre connaissance le fait que vous ayez été admis
                                dans un service ou secteur psychiatrique d&apos;un établissement de
                                santé.
                                <br />
                                Veuillez importer un certificat médical indiquant qu&apos;il
                                n&apos;y a pas de contre-indication à ce que vous puissiez détenir
                                armes.
                                <br />
                                Veuillez cliquer sur &quot;importer&quot; afin d&apos;ajouter un
                                certificat médical indiquant qu&apos;il n&apos;y a pas de
                                contre-indication à ce que vous puissiez détenir et acquérir des
                                armes. Une fois le document importé, veuillez cliquer sur le bouton
                                &quot;Valider&quot;
                            </p>
                            <InputFiles
                                name="certificatMedical"
                                label="Ajouter un certificat médical"
                                error={formState.errors ? formState.errors.certificatMedical : null}
                                register={register('certificatMedical', {
                                    validate: {
                                        tailleTotaleMoinsDe18MBAccepte: (fichiers) =>
                                            tailleFichiers(fichiers) <= 18874368 ||
                                            'La taille totale des fichier dépasse 18Mo',
                                        formatAccepte: (fichiers) =>
                                            formatFichiers(fichiers, mimeTypesAccepted) ||
                                            "Le format d'un des fichiers n'est pas accepté",
                                    },
                                })}
                                required
                            />
                        </ModalV2Content>
                        <ModalV2Footer>
                            <ButtonGroup align="right" inline>
                                <Button name="retour" onClick={fermerModale} disabled={isLoading}>
                                    Retour
                                </Button>
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit(onSubmit)}
                                    isLoading={isLoading}
                                    disabled={disableBoutonValider()}
                                >
                                    Valider
                                </Button>
                            </ButtonGroup>
                        </ModalV2Footer>
                    </ModalV2>
                </form>
            </FormProvider>
        </>
    );
};

ModaleCertificatMedicalDeclaration.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.bool,
    uuidDeclaration: PropTypes.string.isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { isLoading, data } = state.mesDeclarationsArmes.envoyerCertificatMedicalPj;
        return {
            isLoading,
            data,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
    },
)(ModaleCertificatMedicalDeclaration);
